"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var jsx_runtime_1 = require("react/jsx-runtime");
var classnames_1 = __importDefault(require("classnames"));
var ui_common_1 = require("@codametrix/ui-common");
var code_layer_1 = require("../code-layer");
var field_enabler_rules_1 = __importDefault(require("./field-enabler-rules"));
var getValueAtPath = ui_common_1.workBench.pathUtils.getValueAtPath;
var TextInputComponent = function (_a) {
    var field = _a.field, value = _a.value;
    var _b = __read(field.classNames), firstClass = _b[0], rest = _b.slice(1);
    var handleChange = function (event) {
        var userInputValue = event.target.value;
        if (userInputValue !== '' && field.validateInputString) {
            var regex = new RegExp(field.validateInputString);
            if (!regex.test(userInputValue)) {
                return;
            }
        }
        field.onKeyPress(Number(userInputValue), value, field);
    };
    var isEnabled = true;
    if (field.inputEnableRules && field.inputEnableRules.length > 0) {
        isEnabled = (0, field_enabler_rules_1["default"])(field.inputEnableRules, value, 'OR');
    }
    var textInputComponent = ((0, jsx_runtime_1.jsx)("input", { onBlur: function () { }, type: "text", disabled: !isEnabled, value: value['units'], className: (0, classnames_1["default"])(firstClass), onChange: handleChange, "data-testid": "input-field-units" }));
    return (0, jsx_runtime_1.jsx)(code_layer_1.AppliedClassNames, { value: textInputComponent, classNames: rest });
};
exports["default"] = TextInputComponent;
//# sourceMappingURL=text-input-field-component.js.map